import React from 'react';
import {view} from '@sail/ui';

type Props = {
  header: React.ReactNode;
  text: React.ReactNode;
};

export const ErrorBoundaryFallbackUI: React.FC<Props> = ({
  header,
  text,
}): JSX.Element => {
  return (
    <view.div
      css={{
        stack: 'y',
        textAlign: 'center',
        alignX: 'center',
      }}
    >
      <view.h3
        css={{
          font: 'heading.medium',
          fontWeight: 'regular',
          marginBottom: 'small',
        }}
      >
        {header}
      </view.h3>
      <view.span
        css={{
          font: 'body.small',
          color: 'subdued',
          marginBottom: 'large',
        }}
      >
        {text}
      </view.span>
    </view.div>
  );
};
